// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zonas-container {
  max-width: 680px;
  margin: 50px auto 80px auto;
  padding: 0 20px;
  text-align: center;
}

.zonas-titulo {
  font-size: 2rem;
  font-weight: 700;
  color: #111111;
  margin-bottom: 30px;
}

.zonas-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.zonas-tabla {
  margin-bottom: 0;
  width: 100%;
}

.zonas-tabla thead th {
  background-color: #1a1a1a;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  padding: 14px 24px;
  border: none;
}

.zonas-tabla thead th.col-costo {
  width: 140px;
  white-space: nowrap;
}

.zonas-tabla tbody td {
  padding: 16px 24px;
  font-size: 1.05rem;
  vertical-align: middle;
  border-bottom: 1px solid #f1f3f5;
}

.zonas-tabla tbody tr:last-child td {
  border-bottom: none;
}

.zonas-tabla tbody tr {
  transition: background-color 0.15s ease;
}

.zonas-tabla tbody tr:hover {
  background-color: #fcfcfc;
}

.zona-nombre {
  color: #212529;
  font-weight: 500;
  line-height: 1.4;
}

.zona-precio {
  color: var(--color-principal, #E00202);
  font-weight: 700;
  white-space: nowrap;
  width: 140px;
}

.zonas-footer {
  margin-top: 24px;
}

.zonas-nota {
  font-size: 0.95rem;
  color: #6c757d;
  margin: 0;
}

.whatsapp-link {
  color: #25D366;
  font-weight: 600;
  text-decoration: underline;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  transition: color 0.2s;
}

.whatsapp-link:hover {
  color: #1eb956;
}

@media (max-width: 576px) {
  .zonas-container {
    margin: 30px auto 50px auto;
    padding: 0 15px;
  }

  .zonas-titulo {
    font-size: 1.6rem;
    margin-bottom: 20px;
  }

  .zonas-tabla thead th,
  .zonas-tabla tbody td {
    padding: 12px 16px;
    font-size: 0.95rem;
  }

  .zonas-tabla thead th.col-costo,
  .zona-precio {
    width: 110px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/zonas/zonas.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;IAEE,YAAY;EACd;AACF","sourcesContent":[".zonas-container {\n  max-width: 680px;\n  margin: 50px auto 80px auto;\n  padding: 0 20px;\n  text-align: center;\n}\n\n.zonas-titulo {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #111111;\n  margin-bottom: 30px;\n}\n\n.zonas-card {\n  background: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n}\n\n.zonas-tabla {\n  margin-bottom: 0;\n  width: 100%;\n}\n\n.zonas-tabla thead th {\n  background-color: #1a1a1a;\n  color: #ffffff;\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 14px 24px;\n  border: none;\n}\n\n.zonas-tabla thead th.col-costo {\n  width: 140px;\n  white-space: nowrap;\n}\n\n.zonas-tabla tbody td {\n  padding: 16px 24px;\n  font-size: 1.05rem;\n  vertical-align: middle;\n  border-bottom: 1px solid #f1f3f5;\n}\n\n.zonas-tabla tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.zonas-tabla tbody tr {\n  transition: background-color 0.15s ease;\n}\n\n.zonas-tabla tbody tr:hover {\n  background-color: #fcfcfc;\n}\n\n.zona-nombre {\n  color: #212529;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.zona-precio {\n  color: var(--color-principal, #E00202);\n  font-weight: 700;\n  white-space: nowrap;\n  width: 140px;\n}\n\n.zonas-footer {\n  margin-top: 24px;\n}\n\n.zonas-nota {\n  font-size: 0.95rem;\n  color: #6c757d;\n  margin: 0;\n}\n\n.whatsapp-link {\n  color: #25D366;\n  font-weight: 600;\n  text-decoration: underline;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  transition: color 0.2s;\n}\n\n.whatsapp-link:hover {\n  color: #1eb956;\n}\n\n@media (max-width: 576px) {\n  .zonas-container {\n    margin: 30px auto 50px auto;\n    padding: 0 15px;\n  }\n\n  .zonas-titulo {\n    font-size: 1.6rem;\n    margin-bottom: 20px;\n  }\n\n  .zonas-tabla thead th,\n  .zonas-tabla tbody td {\n    padding: 12px 16px;\n    font-size: 0.95rem;\n  }\n\n  .zonas-tabla thead th.col-costo,\n  .zona-precio {\n    width: 110px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
